import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const MaskLines = ({ lines, className = "", lineClass = "", delay = 0.15, testId }) => (
  <h1 className={className} data-testid={testId}>
    {lines.map((l, i) => (
      <span key={i} className="block overflow-hidden pb-[0.06em]">
        <motion.span
          className={`block ${typeof l === "object" && l.className ? l.className : lineClass}`}
          initial={{ y: "105%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 1.05, ease: EASE, delay: delay + i * 0.12 }}
        >
          {typeof l === "object" ? l.text : l}
        </motion.span>
      </span>
    ))}
  </h1>
);

export const Reveal = ({ children, className = "", delay = 0, y = 28, as = "div", ...rest }) => {
  const C = motion[as] || motion.div;
  return (
    <C
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.12 }}
      transition={{ duration: 0.8, ease: EASE, delay }}
      {...rest}
    >
      {children}
    </C>
  );
};

export const SectionHead = ({ eyebrow, title, dark = false, children, testId }) => (
  <Reveal className="max-w-3xl" data-testid={testId}>
    <p className={`eyebrow ${dark ? "text-sky-400" : "text-[#0a6cff]"}`}>{eyebrow}</p>
    <h2 className={`font-display mt-4 text-4xl sm:text-5xl lg:text-6xl font-extrabold uppercase leading-[0.92] tracking-tight ${dark ? "text-white" : "text-slate-950"}`}>
      {title}
    </h2>
    {children && <p className={`mt-5 text-sm md:text-base leading-relaxed ${dark ? "text-slate-300" : "text-slate-600"}`}>{children}</p>}
  </Reveal>
);

export const spotMove = (e) => {
  const r = e.currentTarget.getBoundingClientRect();
  e.currentTarget.style.setProperty("--mx", `${e.clientX - r.left}px`);
  e.currentTarget.style.setProperty("--my", `${e.clientY - r.top}px`);
};
